import { render } from "./ChangePassword.vue?vue&type=template&id=50c94fb8"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"
script.render = render

export default script